<template>
	<Tag
		:key="icon"
		v-tooltip.top="download.status === 'failed' ? download.failure_reason : null"
		class="email-download-status"
		:icon
		:severity
		:value="label" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Tag from 'primevue/tag'
import type { EmailDownload } from '@/models/EmailDownload/Model'

const props = defineProps<{ download: EmailDownload }>()

const label = computed(() => {
	if (props.download.status === 'failed') {
		return props.download.generation_status === 'failed' ? 'ZIP failed' : 'Email failed'
	}
	return {
		queued: 'Queued',
		generating: 'Generating ZIP',
		sending: 'Sending email',
		sent: 'Sent',
		revoked: 'Revoked',
	}[props.download.status]
})
const severity = computed(
	() =>
		({
			queued: 'secondary',
			generating: 'warn',
			sending: 'warn',
			sent: 'success',
			failed: 'danger',
			revoked: 'secondary',
		})[props.download.status],
)
const icon = computed(
	() =>
		({
			queued: 'fal fa-clock',
			generating: 'fal fa-spinner fa-spin',
			sending: 'fal fa-spinner fa-spin',
			sent: 'fal fa-check',
			failed: 'fal fa-exclamation-triangle',
			revoked: 'fal fa-ban',
		})[props.download.status],
)
</script>

<style scoped lang="scss">
.email-download-status {
	white-space: nowrap;
}
</style>
